// Import the functions you need from the SDKs you need

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: 'AIzaSyD69KeFg7XcM0t3FVzXW_G-ARNUhoM9EY8',
  authDomain: 'ecommerce-e8b82.firebaseapp.com',
  projectId: 'ecommerce-e8b82',
  storageBucket: 'ecommerce-e8b82.appspot.com',
  messagingSenderId: '505044683608',
  appId: '1:505044683608:web:1c1d31cfcb76ef47a7b32d',
  databaseURL:
    'https://ecommerce-e8b82-default-rtdb.europe-west1.firebasedatabase.app/',
}

// Initialize Firebase
